//if you end up using bootstrap js components, just uncomment this line
import 'bootstrap';

const urlParams = new URLSearchParams(window.location.search);
const initialInnerWidth = window.innerWidth;
const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
const accordions = document.querySelectorAll('.accordion-collapse');
const buttons = document.querySelectorAll('.accordion-button');

window.onload = function(){
    if (urlParams.get('t') == 1){
        // document.getElementById('terms').scrollIntoView();
        document.getElementById('terms-mobile').click();
        document.getElementById('terms-mobile').scrollIntoView();
    }

    document.getElementById('body-terms-link')?.addEventListener('click', () =>{

      console.log(window.innerWidth);

      var clickTarget;
      var scrollTarget;

      if (viewportWidth >= 576){
        clickTarget = 'terms-expand';
        scrollTarget = 'terms-header';
      } else {
        clickTarget = 'terms-mobile';
        scrollTarget = 'terms-mobile';
      }


      document.getElementById(clickTarget).click();

      setTimeout(() => {
        document.getElementById(scrollTarget).scrollIntoView(true);
      }, 250);

    });

}



// Resize
function handleResize() {

  if (window.innerWidth != initialInnerWidth){

    if (viewportWidth >= 576) {
        accordions.forEach(accordion => accordion.classList.add('show'));
        buttons.forEach(button => button.disabled = true);
    } else {
        accordions.forEach(accordion => accordion.classList.remove('show'));
        buttons.forEach(button => button.disabled = false);
    }
  }

}

// Call Resize
window.addEventListener('resize', handleResize);
// window.addEventListener('DOMContentLoaded', handleResize);
if (viewportWidth >= 576) {
  accordions.forEach(accordion => accordion.classList.add('show'));
  buttons.forEach(button => button.disabled = true);
} else {
  accordions.forEach(accordion => accordion.classList.remove('show'));
  buttons.forEach(button => button.disabled = false);
}

//overwriting SITE-supplied parameters on all outgoing URLs in the event that the user came to the site from an email
//(email links have params) by querying the session cache for the initial parameter string
fetch('/weekend-rental/gettrackingcache', {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
  },
  credentials: 'include'
})
.then(response => response.json())
.then((data) => {
  if(data.trackingString){
    addMissinParams(data.trackingString);
  }
})
.catch((error) => {
  console.error('Error:', error);
});


function addMissinParams(paramString){
  let trackingParamVars = paramString.split('&');
  const externalLinks = document.querySelectorAll("a[href*='mcid=']");

  externalLinks.forEach((link) => {
    let linkHref = link.href;

    //if the paramString and the link contains membershipsource or TLG_CID then we need to replace them on the link with the values on paramString
    if ( (linkHref.indexOf('membershipsource') != -1 || linkHref.indexOf('TLG_CID') != -1) && (paramString.indexOf('membershipsource') != -1 || paramString.indexOf('TLG_CID') != -1) ) {
      trackingParamVars.forEach((trackingParamVar) => {
        let newParamVar = trackingParamVar.split('=')[0];
        let newParamVal = trackingParamVar.split('=')[1];
        if (newParamVar == 'membershipsource') {
          linkHref = linkHref.replace(/(membershipsource=).*?(&)/,'$1' + newParamVal + '$2');
        } 
        if (newParamVar == 'TLG_CID') {
          linkHref = linkHref.replace(/(TLG_CID=).*?(&)/,'$1' + newParamVal + '$2');
        } 
      });

      link.href = linkHref;
    }

    //loop through the tracking parameters pulled from session and see if any of them need to be added to this link
    let linkParams = link.href.split('?')[1];
    let paramsToAdd = "";
    trackingParamVars.forEach((trackingParamVar) => {
      let paramVar = trackingParamVar.split('=')[0];
      if (linkParams.indexOf(paramVar+'=') == -1) {
        //this site link does not have this tracking var so we'll add it
        paramsToAdd += paramsToAdd.length ? '&'+trackingParamVar : trackingParamVar;
      } 
    });

    if (paramsToAdd.length) {
      link.href = link.href.indexOf('?') ? link.href+'&'+paramsToAdd : link.href+'?'+paramsToAdd;
    }
  });

}

// adding this internal link tracking causes the confirmation page to reload after clicking to expand the terms

// //writing to the web tracking table everytime an internal link is clicked
// const internalLinks = document.querySelectorAll("a:not([href*='mcid='])");

// // const localeStrings = ["en_us","en_ca","fr_ca","es_pr","en_gb","en_ie","de_de","es_es","fr_fr"];

// internalLinks.forEach((link) => {

//   link.addEventListener("click", (e) => {

//     //this is only for the airport list link on the back the airport weekend badge
//     e.stopPropagation();

//     let sameWindow = (link.attributes.target == undefined || (link.attributes.target && link.attributes.target.value != "_blank")) ? true : false;

//     if (sameWindow) e.preventDefault();
    
//     let currentLocale;

//     // localeStrings.forEach((el, index) => {
//     //   if(link.href.includes(el)){
//     //     currentLocale = localeStrings[index];
//     //   }
//     // });
//     currentLocale = "en_us";

//     let data = {
//       "URLandParams": link.href,
//       "anchorText": link.text,
//       "locale": currentLocale
//     }

//     if (link.attributes.referrer && link.attributes.referrer.value != "") {
//       data.URLandParams = link.attributes.referrer.value;
//     }

//     fetch('/weekend-rental/addwebtracking', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
//       },
//       credentials: 'include',
//       body: JSON.stringify(data)
//     })
//       .then(response => response.json())
//       .catch((error) => {
//         console.error('Error:', error);
//       }).finally(() => {

//         if(sameWindow){
//           window.location = link.href;
//         }

//       });

//   });

// });

